export default function getTentRules(configuration) {
  const { width, height } = configuration;

  const widthValues = [4, 6, 8, 10, 12, 15, 16, 20, 25, 30, 40];
  const heightValues = width <= 10 ? [2.3, 3] : width <= 15 ? [3, 4] : [4];
  const minimumLengthByWidthIndex = [5, 5, 5, 5, 25, 25, 25, 25, 35, 35, 40];
  const minimumLength = minimumLengthByWidthIndex[widthValues.indexOf(width)];

  return {
    length: {
      default: 10,
      min: minimumLength,
      max: 200,
      step: 5,
    },
    width: {
      default: 10,
      min: 4,
      max: 40,
      values: widthValues,
    },
    height: {
      default: heightValues[0],
      min: heightValues[0],
      max: heightValues[heightValues.length - 1],
      values: heightValues,
    },
    disabledWallTypes: height < 3 ? ['wall_hard_plastic_white', 'wall_glass'] : [],
  };
}
